import styled from "styled-components/macro";
import { ContentFormatter } from "@ebscois/react-component-library";

export const Content = styled(ContentFormatter)`
  max-width: 50rem;

  h1 {
    margin-top: 0;
  }

  u {
    text-decoration: none;
  }

  hr {
    display: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.colors.gray800};
  }

  table {
    table-layout: auto;
    max-width: 100%;
  }

  thead tr td {
    border-top: 1px solid;
  }
`;
